import { supabase } from '@/lib/supabase';

export const updateProjectDescription = async ({
  projectId,
  description,
}: {
  projectId: number;
  description: string;
}) => {
  const { error } = await supabase
    .from('projects')
    .update({ description })
    .eq('id', projectId);
  if (error) throw error;
};
